module.exports = __webpack_public_path__ + "media/images/photos/exterior-2a4a503f7cd46c5e92e587df0309227f.jpg";